<template>
  <svg v-if="number == 1" class="animated-path animated-path-1 scroll-step-2" ref="el" width="555" height="1360" viewBox="0 0 555 1360" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M104 1C104.19 22.5172 101.236 48.7519 102.596 70.2598L4.51567 323.457C4.51567 323.457 -8.14431 442.765 39.3157 517.884C86.7757 593.003 131.546 695.747 149.316 715.468C150.536 716.818 151.976 718.4 152.946 719.76C157.016 725.495 161.946 730.291 167.086 735.179C177.846 745.421 188.346 755.588 199.536 765.401C203.036 768.465 205.926 771.863 209.736 774.619C216.206 779.293 223.606 781.816 231.596 783.213C235.406 783.874 239.076 784.088 242.896 784.517C246.716 784.945 250.386 786.323 254.146 787.226C259.046 788.408 263.786 788.539 268.796 788.483C275.296 788.418 281.446 787.543 287.836 786.621C289.596 786.369 291.396 786.397 293.156 786.174C295.206 785.913 297.346 784.665 299.296 784.544C301.276 784.414 303.106 785.317 305.106 785.42C308.246 785.578 311.356 785.215 314.496 785.596C319.406 786.192 324.236 787.291 329.146 787.924C334.176 788.576 338.476 789.665 343.426 790.801C352.786 792.952 364.066 794.889 371.436 801.257C374.796 804.162 377.566 808.073 380.676 811.257C384.076 814.739 386.786 818.277 389.526 822.244C393.196 827.551 395.826 832.644 401.726 836.396C407.866 840.297 414.646 840.307 421.736 840.344C423.686 840.353 425.556 840.213 427.476 840.074C430.616 839.841 433.386 840.344 436.506 840.94C442.586 842.113 448.776 842.28 454.496 844.748C459.106 846.74 461.456 851.293 464.546 854.869C467.686 858.5 470.516 861.889 472.326 866.284C474.826 872.364 477.686 878.22 480.716 884.095C483.226 888.955 483.666 893.257 485.266 898.331C486.266 901.506 487.756 904.625 488.946 907.754C490.486 911.822 491.386 916.105 492.696 920.258C494.136 924.839 495.216 929.401 497.036 933.889C498.536 937.585 499.246 940.546 499.146 944.503C499.056 948.302 497.566 951.533 496.416 955.174C494.956 959.792 494.546 964.494 493.756 969.242C492.126 979.093 490.516 992.007 498.096 1000.13C507.876 1010.61 519.516 1017.43 532.096 1024.56C540.786 1029.48 544.556 1036.88 547.496 1045.79C549.846 1052.91 549.936 1060.3 550.636 1067.66C550.906 1070.5 551.696 1073.17 551.736 1076.04C551.856 1084.74 551.666 1093.46 551.716 1102.16C551.746 1108.32 550.796 1114.16 549.506 1120.15C549.376 1120.77 549.786 1121.49 549.626 1122.11C549.486 1122.66 548.826 1123.33 548.736 1123.79C548.376 1125.59 548.416 1127.31 548.436 1129.17C548.566 1141.58 549.766 1154 548.686 1166.41C547.886 1175.54 544.726 1184.26 543.326 1193.29C542.636 1197.74 542.216 1201.71 540.636 1205.96C539.226 1209.75 536.766 1210.92 533.496 1213.29C532.146 1214.26 530.836 1215.47 529.256 1216.12C524.466 1218.1 517.396 1216.95 512.476 1218.09C504.126 1220.03 496.836 1224.43 489.246 1228.07C482.936 1231.09 476.516 1234.06 470.536 1237.65C465.116 1240.91 460.116 1245.06 454.926 1248.66C448.846 1252.88 441.796 1258.63 434.916 1261.9C429.036 1264.69 421.606 1266.01 415.366 1268.05C405.436 1271.29 395.546 1273.9 385.856 1277.69C376.126 1281.5 365.736 1283.34 355.866 1286.79C349.566 1288.98 343.976 1292.48 337.556 1294.57C331.796 1296.44 325.486 1297.89 319.416 1298.74C315.266 1299.32 310.876 1298.92 306.696 1298.87C293.586 1298.74 282.586 1301.36 270.646 1305.95C259.156 1310.36 246.906 1314.22 236.776 1321.14C227.086 1327.76 222.266 1336.89 218.326 1347.23C217.536 1349.31 216.996 1350.99 216.556 1353.05C216.266 1354.42 216.356 1357.48 215.756 1358.71" stroke="#FBDE41" stroke-width="5" stroke-miterlimit="10" :style="{ 'stroke-dashoffset': offset }"/>
  </svg>

  <svg v-if="number == 2" class="animated-path animated-path-2 scroll-step-2" ref="el" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="112.25 856.84 279.39 1759.02">
    <path d="M114.755 859.337 115.695 868.685C116.335 875.007 117.605 880.026 116.875 886.534C116.145 893.098 115.685 899.355 115.745 905.966C115.935 927.483 114.405 948.776 115.765 970.284L152.755 1116.53C156.255 1213.98 163.575 1311.04 178.885 1407.56C180.315 1416.55 180.845 1425.9 181.645 1434.95C182.765 1447.6 179.735 1460.45 177.155 1472.83C174.295 1486.54 172.115 1500.34 169.465 1514.07C166.855 1527.56 162.305 1540.62 159.495 1554.03C157.625 1562.93 157.385 1571.56 157.075 1580.57C156.875 1586.52 155.145 1592.23 154.855 1598.16C154.125 1612.75 155.775 1628.18 160.035 1642.21C164.635 1657.37 176.905 1668.27 183.625 1682.68C190.945 1698.39 197.135 1714.5 204.645 1730.2C211.555 1744.63 218.545 1758.57 227.365 1772.1C232.545 1780.04 236.585 1785.45 237.525 1794.8C238.165 1801.12 239.435 1806.14 238.705 1812.65C237.975 1819.21 237.515 1825.47 237.575 1832.08C237.765 1853.6 236.235 1874.89 237.595 1896.4L139.515 2149.59C139.515 2149.59 126.855 2268.9 174.315 2344.02C221.775 2419.14 266.545 2521.89 284.315 2541.61C285.535 2542.96 286.975 2544.54 287.945 2545.9C292.015 2551.63 296.945 2556.43 302.085 2561.32C312.845 2571.56 323.345 2581.73 334.535 2591.54C338.035 2594.6 340.925 2598 344.735 2600.76C351.205 2605.43 358.605 2607.95 366.595 2609.35C370.405 2610.01 374.075 2610.23 377.895 2610.65C381.715 2611.08 385.385 2612.46 389.145 2613.36C394.045 2614.55 398.785 2614.68 403.795" stroke="#FBDE41" stroke-width="5" :style="{ 'stroke-dashoffset': offset }" />
  </svg>
</template>

<script>
import signals from '@/store/signals'
import { raf } from '@internet/raf'
import Inrtia from 'inrtia'

export default {
  name: 'AnimatedPath',
  props: {
    number: {
      type: Number,
      default: 1,
    },
  },
  mounted() {
    this.minOffset = 0
    this.maxOffset = 1900

    setTimeout(() => {
      if (this.$refs.el) {
        this.initInrtia()
        this.bindExternal()
      }
    }, 1000)
  },
  data () {
    return {
      offset: 1900,
    }
  },
  methods: {
    initInrtia () {
      const inrtiaOptions = {
        value: this.maxSOffset,
        friction: 7,
        precision: 5,
        perfectStop: true,
        interpolation: 'linear',
      }

      this.inrtia = new Inrtia(inrtiaOptions);
    },
    bindExternal () {
      signals.startingSection2.listen(this.checkSectionStart)
      signals.endingSection2.listen(this.checkSectionEnd)
    },
    unbindExternal () {
        signals.startingSection2.unlisten(this.checkSectionStart)
        signals.endingSection2.unlisten(this.checkSectionEnd)
    },
    bind () {
        if (this.isBinded) return
        this.isBinded = true
        signals.progressUpdate2.listen(this.update)

        this.bindInrtia()
        this.unbindAsked = false
    },
    unbind () {
      if (!this.isBinded) return
      this.isBinded = false
      signals.progressUpdate2.unlisten(this.update)

      this.unbindAsked = true

      const distMin = Math.abs(this.offset - this.minOffset)
      const distMax = Math.abs(this.offset - this.maxOffset)

      if (distMin < distMax) {
          this.offset = this.minOffset
          this.inrtia.to(this.offset)
      } else {
          this.offset = this.maxOffset
          this.inrtia.to(this.offset)
      }
    },
    bindInrtia () {
      if (this.inrtiaBinded) return
      this.inrtiaBinded = true
      raf.add(this.updateInrtia);
    },
    unbindInrtia () {
      this.inrtiaBinded = false
      raf.remove(this.updateInrtia);
    },
    checkSectionStart (response) {
      if (!this.$refs.el?.dataset.scrollamaIndex) return
      if (response.index == Number(this.$refs.el?.dataset.scrollamaIndex)) this.bind()
    },
    checkSectionEnd (response) {
      if (!this.$refs.el?.dataset.scrollamaIndex) return
      if (response.index == Number(this.$refs.el?.dataset.scrollamaIndex)) this.unbind()
    },
    update (response) {
      if (response.progress === 1 || response.progress === 0) return
      
      this.offset = this.maxOffset - (response.progress * this.maxOffset)

      this.inrtia.to(this.offset)
    },
    updateInrtia () {
      if (!this.inrtia.stopped) {
          const offset = this.inrtia.update();
          if ((offset < (this.minOffset + 50) || offset > (this.maxOffset - 50)) && this.unbindAsked) this.unbindInrtia()
      }
    }
  },
  beforeUnmount () {
    this.unbindExternal()
    this.unbind()
  }
}
</script>

<style lang="scss">
.animated-path-1 {
  path {
    stroke-dasharray: 1900;
    stroke-dashoffset: 1900;
  }
}

.animated-path-2 {
  path {
    stroke-dasharray: 1900;
    stroke-dashoffset: 1900;
  }
}
</style>
